import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-MapModeLegendContainer',
	legendItem: 'c-MapModeLegendItem',
	legendIcon: 'c-MapModeLegendItem__icon',
	legendText: 'c-MapModeLegendItem__text',

	legendIconLine: 'c-MapModeLegendItem__icon__line',
	legendCollectionLabelOverride: 'c-MapModeLegendItem__icon__label',
};

export const Style = {
	[CSS.container]: {
		position: 'relative',
		flexGrow: '1',
		maxHeight: '30%',
		padding: DefaultTheme.space(1),
		overflow: 'auto',
	},
	[CSS.legendItem]: {
		display: 'flex',
		height: '28px',
		boxSizing: 'border-box',
		padding: `${DefaultTheme.space(1)} ${DefaultTheme.space(2)}`,
	},
	[CSS.legendIcon]: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '32px',
		height: '100%',
	},
	[CSS.legendIconLine]: {
		height: '4px',
		width: '100%',
	},
	[CSS.legendCollectionLabelOverride]: {
		width: '100%',
		padding: 0,
		textAlign: 'center',
	},
	[CSS.legendText]: {
		display: 'flex',
		alignItems: 'center',
		paddingLeft: '12px',
	},
};
